import React from 'react';
import PropType from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from 'reactstrap';
import { Form, Input, Select, Checkbox } from 'antd';
import { FormattedMessage } from 'react-intl';
import './styles.scss';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { CAR_CATEGORIES, CAR_FUELS, CAR_SEGMENTS, CAR_GEARS } from './constants';
import { FromSubmitButton, FromCancelButton, ItemButton } from '../UIKit';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';
import { saveCar, updateCar } from './actions';
import { makeSelectCarResponse, makeSelectCarCreator } from './selectors';
import { makeSelectCar } from 'components/CarSelector/selectors';

const carDefaultValues = {
  segmento: 'A',
  category: 'berlina',
  fuel: 'benzina',
};

const carFields = [
  {name: "category", type: "select", required: true, options: CAR_CATEGORIES},
  {name: "fuel", type: "select", required: true, options: CAR_FUELS},
  {name: "segmento", type: "select", required: true, options: CAR_SEGMENTS},
  {name: "allestimento", type: "text", required: true},
  {name: "neo_patentati", type: "check", required: false},
  {name: "cilindrata", type: "text", required: true},
  {name: "cavalli_fiscali", type: "text", required: true},
  {name: "descrizione_trazione", type: "text", required: true},
  {name: "desc_motore", type: "text", required: true},
  {name: "hp", type: "text", required: true},
  {name: "consumo_medio", type: "text", required: true},
  {name: "kw", type: "text", required: true},
  {name: "euro", type: "text", required: true},
  {name: "emissioni_co2", type: "text", required: true},
  {name: "descrizione_cambio", type: "select", required: true, options: CAR_GEARS},
  {name: "larghezza", type: "text", required: true},
  {name: "lunghezza", type: "text", required: true},
  {name: "bagagliaio", type: "text", required: true},
  {name: "posti", type: "text", required: true},
  {name: "porte", type: "text", required: true},
]

class CarCreator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      errors: new Set(),
    };
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnCancel = this.handleOnCancel.bind(this);
    this.handleOnShow = this.handleOnShow.bind(this);
    this.handleOnInputChange = this.handleOnInputChange.bind(this);
  }

  componentWillUnmount() {
    // default values
    this.props.updateCar(carDefaultValues);
  }

  handleOnCancel() {
    this.setState({ modal: false });
    // default values
    this.props.updateCar(carDefaultValues);
  }

  handleOnShow() {
    this.setState({ modal: true });
  }

  handleOnSubmit() {
    const { existentCar, creatingCar, updateCar, storeCar, brand, modello } = this.props;
    const car = {...existentCar, ...creatingCar};
    car.brand = brand;
    car.modello = modello;
    updateCar(car);
    storeCar();
    this.setState({ modal: false });
  }

  handleOnInputChange(key, value) {
    let { errors } = this.state;
    const { existentCar, creatingCar, updateCar } = this.props;
    let car = {...existentCar, ...creatingCar};

    if (value === null || value === '' || value === undefined) {
      errors.add(key);
    } else {
      errors.delete(key);
    }
    car[key] = value;

    this.setState({ errors });

    updateCar(car);
  }

  get requiredFilled() {
    const { creatingCar, existentCar } = this.props;
    const car = {...existentCar, ...creatingCar};

    return carFields
              .filter(carField => carField.required)
              .every(carField => car[carField.name] && car[carField.name].trim() !== '');
  }

  get canSubmit() {
    const { errors } = this.state;
    return errors.size === 0 && this.requiredFilled;
  }

  inputHasError(key) {
    return this.state.errors.has(key);
  }

  render() {
    const { button, creatingCar, existentCar, isCustomCar, carId, modello } = this.props;
    const { modal } = this.state;
    const car = {...existentCar, ...creatingCar, modello};
    const canEdit = isCustomCar || !carId;

    let icon = 'os-icon-plus-circle';

    if (isCustomCar) {
      icon = 'os-icon-text-input';
    } else if (carId && !isCustomCar) {
      icon = 'os-icon-agenda-1';
    }

    return (
      <div id="CarCreator">
        <ItemButton text={button} onClick={this.handleOnShow} osIcon={icon} />
        <Modal isOpen={modal} toggle={this.handleOnCancel} size="lg">
          <ModalHeader
            toggle={this.handleOnCancel}
            className="CarCreator-modal-header"
          >
            <FormattedMessage {...messages.title} />
          </ModalHeader>
          <ModalBody className="CarCreator-modal-content">
            <Form layout="vertical">
              <Row>
                <Col md={4} sm={4}>
                  <InputItem
                    name="modello"
                    type="text"
                    value={car.modello}
                    disabled={true}
                    required={false}
                  />
                </Col>
                {carFields.map(carField => (
                  carField.type === "check" ?
                  <Col md={4} sm={4} key="neo_patentati">
                    <Form.Item label={messages.neo_patentati.defaultMessage}>
                      <Checkbox
                        checked={car.neo_patentati || false}
                        name="neo_patentati"
                        disabled={!canEdit}
                        onChange={({target: {checked}}) =>
                          this.handleOnInputChange('neo_patentati', checked)
                        }
                      >
                        Sì
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  :
                  <Col md={4} sm={4} key={carField.name}>
                    <InputItem
                      name={carField.name}
                      isValid={this.inputHasError(carField.name)}
                      type={carField.type}
                      value={car[carField.name]}
                      disabled={!canEdit}
                      onChange={value =>
                        this.handleOnInputChange(carField.name, value)
                      }
                      {...carField.options && {options:{...carField.options}}}
                    />
                  </Col>
                  )
                )}
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            {canEdit
            ?
            <>
              <FromCancelButton
                text={messages.cancel.defaultMessage}
                onClick={this.handleOnCancel}
              />
              <FromSubmitButton
                text={messages.submit.defaultMessage}
                onClick={this.handleOnSubmit}
                disabled={!this.canSubmit}
              />
            </>
            :
              <FromCancelButton
                text={messages.close.defaultMessage}
                onClick={this.handleOnCancel}
              />
            }
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const InputItem = ({
  name,
  value,
  isValid,
  onChange,
  disabled,
  type = 'text',
  options = [],
  required = true,
}) =>
    <Form.Item label={messages[name].defaultMessage} validateStatus={isValid ? 'error' : null} required={required}>
      {type === 'select' ? (
        <Select name={name} value={value || ''} onChange={onChange} disabled={disabled}>
          <Select.Option value=" "> </Select.Option>
          {options.hasOwnProperty('size')
            ? null
            : Object.values(options).map(option => (
                <Select.Option value={option.value} key={option.value}>
                  {option.description}
                </Select.Option>
              ))}
        </Select>
      ) : (
        <Input
          type={type}
          name={name}
          value={value || ''}
          disabled={disabled}
          onChange={({target: {value}}) => onChange(value)}
          autoComplete="off"
        />
      )}
    </Form.Item>

CarCreator.propTypes = {
  brand: PropType.string.isRequired,
  modello: PropType.string.isRequired,
  storeCar: PropType.func.isRequired,
  button: PropType.string.isRequired,
  isCustomCar: PropType.bool.isRequired,
  carId: PropType.number,
};

export function mapDispatchToProps(dispatch) {
  return {
    storeCar: () => dispatch(saveCar()),
    updateCar: car => dispatch(updateCar(car)),
  };
}

const mapStateToProps = createStructuredSelector({
  response: makeSelectCarResponse(),
  creatingCar: makeSelectCarCreator(),
  existentCar: makeSelectCar(),
});

const withReducer = injectReducer({ key: 'carCreator', reducer });
const withSaga = injectSaga({ key: 'carCreator', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(CarCreator);
